var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCounterNotificationClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    fill: "none",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#F31919"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M13.552 14.394a1.781 1.781 0 0 0 0 2.579L22.888 26l-9.336 9.027a1.781 1.781 0 0 0 0 2.58c.737.711 1.931.711 2.668 0l9.335-9.028 10.225 9.887c.737.712 1.931.712 2.668 0a1.781 1.781 0 0 0 0-2.58L28.223 26l10.225-9.887a1.781 1.781 0 0 0 0-2.579 1.932 1.932 0 0 0-2.668 0l-10.225 9.887-9.335-9.027a1.932 1.932 0 0 0-2.668 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCounterNotificationClose);
export default __webpack_public_path__ + "static/media/ic_counter_notification_close.f886a1621c954518829bd5a9da915e36.svg";
export { ForwardRef as ReactComponent };